import { useState } from "react";
import { Controller } from "react-hook-form";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import CustomDialog from "../CustomDialog";
import NullCheck from "../NullCheck";
import {
  Icon,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";

const SelectIconInput = ({
  control,
  title,
  name,
  required,
  errors,
  width,
  validation,
  options,
  defaultValue,
}) => {
  const { bt } = useBizTypeTranslation();
  const [openMassge, setOpenMassge] = useState(false);
  const error = errors ? errors[name]?.ref?.name : false;
  const massge = errors ? errors[name]?.message : "";

  return (
    <Stack>
      <Controller
        name={name}
        control={control}
        label={`${required ? "*" : ""}${bt(title)}`}
        rules={{
          required: required ? bt("REQUIRED") : false,
          pattern: {
            value: validation?.regex,
            message: bt(validation?.massge),
          },
        }}
        render={({ field: { onChange, value } }) => (
          <Select
            error={error === `${name}`}
            autoWidth
            MenuProps={{
              MenuListProps: {
                sx: {
                  height: 250,
                  width: 240,
                  padding: 1,
                  gap: 1,
                  "&.MuiMenu-list": {
                    display: "flex",
                    flexWrap: "wrap",
                  },
                },
              },
            }}
            sx={{ width: width ? width : 90, paddingX: 1 }}
            size="small"
            defaultValue={defaultValue ?? 1}
            value={value}
            onChange={onChange}
          >
            {options?.map((option) => {
              return (
                <MenuItem
                  key={option}
                  sx={{ width: 50, height: 50, border: "1px solid black" }}
                  value={option}
                >
                  <Stack>
                    <Icon sx={{ fontSize: "20px" }}>{option}</Icon>
                  </Stack>
                </MenuItem>
              );
            })}
          </Select>
        )}
      />

      <NullCheck valueForCheck={massge}>
        <CustomDialog
          title="ERROR"
          open={openMassge}
          width={300}
          onClose={() => setOpenMassge(false)}
          closeBtn="CLOSE"
        >
          <Stack alignItems="center">
            {massge}
          </Stack>
        </CustomDialog>
      </NullCheck>
    </Stack>
  );
};
export default SelectIconInput;
